import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
// Hooks
import useAccountStatus from 'app/hooks/useAccountStatus';

interface ProtectedRouteProps extends RouteProps {
  allowSuspended?: boolean;
  redirectTo?: string;
  component: React.ComponentType<any>;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  allowSuspended = false,
  redirectTo = '/',
  ...rest
}) => {
  const { isSuspended } = useAccountStatus();

  return (
    <Route
      {...rest}
      render={(props) =>
        isSuspended && !allowSuspended ? (
          <Redirect to={redirectTo} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default ProtectedRoute;
